<div id="subnav-files" class="subnav flex-row flex-center-y">
  <div class="search flex-1 flex-row flex-center-y">
    <input
        type="text"
        placeholder="Search files"
        [(ngModel)]="search_query"
        (keyup.enter)="getFiles()"
      />
      <ng-container *ngIf="search_is_active">
        <div class="clear-search" (click)="clearSearch()">
          <span>Clear</span>
        </div>
      </ng-container>
  </div>
  <div class="options flex-row">
    <div id="filter" class="filter-control">
      <div class="filter-icon flex-row flex-center-y" (click)="toggleFilters()">

          <span class="text-color-primary" *ngIf="sumOfFilterLength()">
            {{ sumOfFilterLength() }}
          </span>

          <svg xmlns="http://www.w3.org/2000/svg"
               width="25"
               height="25"
               viewBox="0 0 24 24"
               fill="none"
               stroke="#000000"
               stroke-width="1"
               stroke-linecap="round"
               stroke-linejoin="round">

        <path d="M4 4h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v7l-6 2v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227z" />
      </svg>
      </div>

      <file-filter *ngIf="show_filters"
                   (filter_selelected_type)="onFilterTypeChange($event)"
                   (filter_cleared_type)="onFilterTypeClear()"
                   [active_filter_types]="filter_fileType">
      </file-filter>
      <div *ngIf="show_filters" 
           class="filter-backdrop" 
           (click)="toggleFilters()"></div>
   
    </div>
  </div>

</div>

<div class="wrapper wrapper-medium">

  <div class="header">
    <h1>Files</h1>
  </div>

  <div *ngIf="isLoading" class="loading-indicator">
    <loading message="retrieving files..."></loading>
  </div>

  <div *ngIf="!isLoading && file_data.documents.length > 0" class="file-list">
    <saffron-list-item
      *ngFor="let file of file_data.documents"
      [file]="file"
      (fileDeleted)="refreshFileList()">
    </saffron-list-item>
  </div>
</div>
